import { PatientWithAccessRightDTO } from '@peartherapeutics/weaver-api-client';
import { createAction, Action } from 'redux-actions';

export const actionTypes = {
  GET_PATIENT_DETAILS_LIST_SUCCESS: 'GET_PATIENT_DETAILS_LIST_SUCCESS',
  GET_PATIENT_DETAILS_LIST_ERROR: 'GET_PATIENT_DETAILS_LIST_ERROR',
};

export const getPatientDetailsListSuccess: (
  payload: PatientWithAccessRightDTO[],
) => Action<void> = createAction(actionTypes.GET_PATIENT_DETAILS_LIST_SUCCESS);

export const getPatientDetailsListError: () => Action<void> = createAction(
  actionTypes.GET_PATIENT_DETAILS_LIST_ERROR,
);
